import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-confirm-year-modal',
	templateUrl: './confirm-year-modal.component.html',
	styleUrls: ['./confirm-year-modal.component.scss'],
	standalone: false,
})
export class ConfirmYearModalComponent {
	private translate = inject(TranslateService);
	private modalCtrl = inject(ModalController);

	public canDrinkCheckbox: boolean = false;
	public fsk: number;

	constructor() {}

	static async show(modalCtrl: ModalController, fsk: number): Promise<boolean> {
		const modal = await modalCtrl.create({
			component: ConfirmYearModalComponent,
			cssClass: 'auto-height confirm-year-modal',
			showBackdrop: true,
			backdropDismiss: true,
			componentProps: {
				fsk,
			},
		});
		await modal.present();
		const result = (await modal.onDidDismiss()).data;
		return result;
	}

	dismissWithData() {
		this.modalCtrl.dismiss(this.canDrinkCheckbox);
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
